const submitButton = document.querySelector('#submitBtn')

const resultElement = document.querySelector('#response')
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const inputs = document.querySelectorAll('#subscribeform input')
const submitForm = e => {
	e.preventDefault()
	let isCorrect = true

	inputs.forEach(input => {
		if (input.type === 'checkbox' && !input.checked) {
			resultElement.innerHTML = 'Zaznacz wymagane pole'
			isCorrect = false
		} else if (input.type === 'email' && !emailRegex.test(input.value)) {
			resultElement.innerHTML = 'Podaj poprawny adres e-mail'
			isCorrect = false
		}
	})

	const form = document.querySelector('#subscribeform')
	const formData = new FormData(form)

	formData.set('emailconfirm', `${formData.get('email')}`)
	if (isCorrect) {
		resultElement.innerHTML = ''
		fetch('https://www.ministerstworeklamy.com.pl/lists/?p=asubscribe&id=1', {
			method: 'POST',
			body: formData
		})
			.then(response => response.text())
			.then(data => {
				const resultElement = document.querySelector('#response')
				resultElement.innerHTML =
					data !== '' ? 'Dziękujemy! Zostałeś dodany do naszego newslettera :)' : 'Coś poszło nie tak ;/'
				resultElement.style.color = '#fff'
				form.reset()
				dataLayer.push({ event: 'newsletter_sent' })
				setTimeout(() => {
					resultElement.style.color = 'transparent'
				}, 5000)
			})
			.catch(error => {
				console.error('Error:', error)
			})
	}
}

submitButton.addEventListener('click', submitForm)
